import { render, staticRenderFns } from "./functionBox.vue?vue&type=template&id=0ae61a21&scoped=true&"
import script from "./functionBox.vue?vue&type=script&lang=js&"
export * from "./functionBox.vue?vue&type=script&lang=js&"
import style0 from "./functionBox.vue?vue&type=style&index=0&id=0ae61a21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae61a21",
  null
  
)

export default component.exports